// extracted by mini-css-extract-plugin
module.exports = {"cartTotal":"CartFooter_cartTotal___Vd_x","btnMargin":"CartFooter_btnMargin__3-A9a"};